import Component from './thank'

export default Component